import Branch from '@/api/Branch'
import Functions from '@/functions'

export default {
  namespaced: true,
  state: {
    select: [],
  },
  mutations: {
    SET_SELECT_OPTIONS(state, data) {
      state.select = data
    },
  },
  actions: {
    select({commit}) {
      return Branch.select().then(res => {
        commit('SET_SELECT_OPTIONS', res.data.message.data)
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
  },
  getters: {}
}
